/* Slider-style product card behaviour: quick-add + colour swatch swap.
   Delegated + idempotent so it works for cards rendered anywhere. */
(function () {
  if (window.__slcInit) return;
  window.__slcInit = true;

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .cnav__count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var drawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(cart);
      });
  }

  function addToCart(id, btn) {
    if (!id || btn.classList.contains('is-adding')) return;
    btn.classList.add('is-adding');
    var orig = btn.innerHTML;
    if (btn.classList.contains('slc-size')) btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        btn.classList.add('is-added');
        if (btn.classList.contains('slc-size')) btn.textContent = '✓';
        setTimeout(function () { btn.innerHTML = orig; btn.classList.remove('is-added', 'is-adding'); }, 1500);
        return refreshCart();
      })
      .catch(function () {
        if (btn.classList.contains('slc-size')) btn.textContent = '!';
        setTimeout(function () { btn.innerHTML = orig; btn.classList.remove('is-adding'); }, 1500);
      });
  }

  document.addEventListener('click', function (e) {
    /* Quick add: click size = add that variant */
    var size = e.target.closest('.slc-size[data-vid]');
    if (size) {
      e.preventDefault();
      if (!size.classList.contains('is-sold') && !size.disabled) addToCart(size.getAttribute('data-vid'), size);
      return;
    }
    /* Single-variant / mobile add button */
    var add = e.target.closest('[data-slc-add]');
    if (add) {
      e.preventDefault();
      addToCart(add.getAttribute('data-slc-add'), add);
      return;
    }
    /* Mobile size panel toggle */
    var toggle = e.target.closest('[data-slc-mtoggle]');
    if (toggle) {
      e.preventDefault();
      var wrap = toggle.closest('.slc-imgwrap');
      var panel = wrap && wrap.querySelector('.slc-msizes');
      if (panel) {
        document.querySelectorAll('.slc-msizes.is-open').forEach(function (p) { if (p !== panel) p.classList.remove('is-open'); });
        panel.classList.toggle('is-open');
      }
      return;
    }
    /* Swatch swap */
    var sw = e.target.closest('.slc-swatch[data-img]');
    if (sw) {
      var card = sw.closest('[data-slc-card]');
      if (!card) return;
      card.querySelectorAll('.slc-swatch').forEach(function (s) { s.classList.remove('is-active'); });
      sw.classList.add('is-active');
      var img = card.querySelector('.slc-img-primary');
      var url = sw.getAttribute('data-img');
      if (img && url) {
        img.src = url;
        img.srcset = url.replace(/width=\d+/, 'width=360') + ' 360w, ' + url.replace(/width=\d+/, 'width=533') + ' 533w, ' + url + ' 720w';
      }
      var hover = card.querySelector('.slc-img-hover');
      var img2 = sw.getAttribute('data-img2');
      if (hover) { if (img2) { hover.src = img2; hover.style.display = ''; } else { hover.style.display = 'none'; } }
      var colorEl = card.querySelector('[data-slc-color]');
      if (colorEl) colorEl.textContent = sw.getAttribute('data-color') || '';
      var priceEl = card.querySelector('[data-slc-price]');
      if (priceEl && sw.getAttribute('data-price')) priceEl.innerHTML = sw.getAttribute('data-price');
      var purl = sw.getAttribute('data-url');
      if (purl) card.querySelectorAll('.slc-image, [data-slc-info]').forEach(function (a) { a.setAttribute('href', purl); });
      return;
    }
    /* Close mobile panels on outside click */
    if (!e.target.closest('.slc-imgwrap')) {
      document.querySelectorAll('.slc-msizes.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    }
  });
})();
